import React, { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { isRusPost } from '../../../../config/providers';

import { useTranslation } from '../../../../i18n';

import { actions as ratesActs, DeliveryType } from '../../../../entities/rates';
import { getDeliveryType } from '../../../../entities/rates/selectors';
import { getInboundCountry, getParcelWeight, hasAlertErrors } from '../../../../entities/providers/selectors';

import { Radio } from '../../../element';
import { BlockHighLight } from '../../../ui/block-highlight';

const deliveryOptions = [
  {
    value: DeliveryType.department,
    label: 'rates.delivery.options.department',
  },
  {
    value: DeliveryType.courier,
    label: 'rates.delivery.options.courier',
  },
];

export const DeliveryMethod: React.FC = () => {
  const [t] = useTranslation('rates');

  const dispatch = useDispatch();

  const inbound = useSelector(getInboundCountry);
  const delivery = useSelector(getDeliveryType);
  const weight = useSelector(getParcelWeight);

  const handleChange = useCallback((value: DeliveryType) => {
    dispatch(ratesActs.setDelivery({ delivery: value }));
  }, []);

  // method to check if some options is disabled
  const canDeliver = useCallback(
    (deliver: DeliveryType): boolean => {
      if (isRusPost(inbound.provider)) {
        if (weight > 20 && deliver === DeliveryType.department) {
          return false;
        }
      }

      return true;
    },
    [inbound.provider, weight]
  );

  // handle already selected disabled option
  useEffect(() => {
    if (isRusPost(inbound.provider)) {
      const options = deliveryOptions.filter(({ value }) => canDeliver(value));

      if (options.length === 1) {
        const { value } = options[0];

        dispatch(ratesActs.setDelivery({ delivery: value }));
      }
    }
  }, [canDeliver, weight]);

  const highLight = useSelector(hasAlertErrors('ua_city_courier'));

  return (
    <BlockHighLight show={highLight}>
      <h2>{t('rates.delivery.title')}</h2>

      <Radio.Group value={delivery} onChange={handleChange}>
        {deliveryOptions.map(({ value, label }) => (
          <Radio disabled={!canDeliver(value)} checked={delivery === value} key={value} value={value} className="mb-10">
            {t(label)}
          </Radio>
        ))}
      </Radio.Group>
    </BlockHighLight>
  );
};
